<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	.top
		width:100%;
		position: relative;
		.top-img
			width:100%
			height:416px
		.top-main
			position: absolute;
			top:100px;
			left:35%;
			width:601px;
			margin:0 auto;
			.top-main-imgs
				display:flex;
				justify-content:center;
				.top-main-img
					width:210px;
					height:41px;
					margin-bottom:22px;
			.top-main-desc
				width:601px;
				height:60px;
				font-size:16px;
				font-weight:400;
				color:rgba(255,255,255,1);
				line-height:30px;
	.tag
		margin-bottom:50px;
		.tag-top
			text-align:center;
			margin-top:100px;
			.tag-top-title
				height:59px;
				font-size:42px;
				font-weight:400;
				color:rgba(7,19,54,1);
				line-height:59px;
			.tag-top-desc
				margin-top:14px;
				height:22px;
				font-size:16px;
				font-weight:400;
				color:rgba(7,19,54,0.4);
				line-height:22px;
		.pattern
			display:flex;
			justify-content:center;
			margin-top:60px;
			padding:0px 15%;
			align-items:center;
			text-align:center;
			.p-left
				margin-right:26px;
				position: relative;
				.p-left-top
					position: absolute;
					top:-85px;
					left:40px;
				.p-left-bottom
					position: absolute;
					bottom:-85px;
					left:40px;
				.p-left-name
					width:71px;
					height:71px;
					line-height:71px;
					text-align:center;
					font-size:20px;
					color:rgba(255,255,255,1);
					background:#FFBB4C;
					border-radius:50%;
					opacity:1;
			.p-c-list
				.p-img
					width:170px;
					height:170px;
			.p-desc
				margin:0 12px;
				.p-c-name
					height:30px;
					font-size:22px;
					// font-weight:bold;
					color:rgba(0,0,0,1);
					opacity:1;
				.p-c-img
					width:150px;
					height:4px;
			.p-right
				margin-left:26px;
				position: relative;
				.p-r-top
					position: absolute;
					top:-85px;
					right:40px;
				.p-r-bottom
					position: absolute;
					bottom:-85px;
					right:40px;
				.p-right-name
					width:71px;
					height:71px;
					display:flex;
					justify-content:center;
					align-items:center;
					font-size:20px;
					color:rgba(255,255,255,1);
					background:#FE757D;
					border-radius:50%;
					opacity:1;
					.p-r-desc
						width:40px;
						height:50px;
						font-size:20px;
						font-weight:400;
						line-height:22px;
						color:rgba(255,255,255,1);
		.s-list
			display:flex;
			justify-content:center;
			margin-top:40px;
			.s-lists
				padding:48px 34px;
				margin:0px 25px;
				display:flex;
				width:408px;
				height:172px;
				background:rgba(255,255,255,1);
				box-shadow:0px 2px 20px 0px rgba(225,225,225,0.5);
				border-radius:10px;
				.s-img
					width:70px;
					height:70px;
					flex-shrink: 0;
				.s-right
					text-align:left;
					margin-left:10px;
					.s-name
						height:28px;
						font-size:20px;
						font-weight:500;
						color:rgba(7,19,54,1);
						line-height:28px;
					.s-desc
						height:44px;
						font-size:16px;
						font-weight:400;
						color:rgba(7,19,54,0.6);
						line-height:22px;
						margin-top:10px;
		.l-list
			display:flex;
			justify-content:center;
			margin-top:60px;
			.l-lists
				padding:29px 25px;
				margin:0px 15px;
				display:flex;
				align-items:center;
				width:362px;
				height:90px;
				background:rgba(255,255,255,1);
				box-shadow:0px 2px 20px 0px rgba(225,225,225,0.5);
				border-radius:10px;
				position:relative;
				.l-img
					width:32px;
					height:32px;
					flex-shrink: 0;
				.l-name
					width:160px;
					height:28px;
					font-size:20px;
					font-weight:bold;
					line-height:28px;
					color:rgba(7,19,54,1);
					opacity:1;
					margin-left:20px;
				.l-desc
					width:72px;
					height:25px;
					font-size:18px;
					font-weight:400;
					line-height:25px;
					color:rgba(7,19,54,1);
					opacity:1;
					margin-left:24px;
				.p-img-bj
					position: absolute;
					z-index:-1;
					right:-20px;
					bottom:-20px;
					width:85px;
					height:85px;
	.bottom
		text-align:center;
		margin-bottom:60px;
		.b-btn
			margin:0 auto;
			background:#2751CB;
			width:200px;
			height:40px;
			line-height:40px;
			color:#FFFFFF;
			font-size:16px;
			border-radius:20px;
			cursor:pointer;
		.b-img
			width:43px;
			height:43px;
			margin:40px 0 8px 0;
		.b-desc
			margin:0 auto;
			width:294px;
			height:20px;
			font-size:14px;
			font-weight:300;
			line-height:20px;
			color:rgba(102,102,102,1);
			opacity:1;
	.dia-body
		margin:0 0 40px 30px;
		.dia-list
			display:flex;
			font-size:16px;
			color:#000;
			margin:10px 40px;
			height:40px;
			align-items:center;
			.dia-des
				margin-left:10px;
			.dia-btn
				cursor:pointer;
				padding:0px 19px;
				height:36px;
				line-height:36px;
				background:rgba(39,81,203,1);
				border-radius:22px;
				border:1px solid rgba(39,81,203,1);
				font-size:14px;
				font-weight:500;
				color:rgba(255,255,255,1);
				margin-left:10px;
</style>
<template>
  <div class="main">
    <div class="top">
    	<img src="/static/img/banner_department.png" class="top-img">
    	<div class="top-main">
    		<div class="top-main-imgs">
    		<img src="/static/img/logo_department1.png" class="top-main-img">
    		</div>
    		<div class="top-main-desc">企业法务部实行“3+1”法律服务模式，由分别擅长劳动法、合同法、公司法领域的三名律师组成法律服务团队，并配置商务经理一名。为企业提供一个在线协同工作系统，及时高效地解决企业法律问题，一键送达、信息共享、互联互通。企业可时刻感受律师提供的服务，就像在企业办公室设置了一个法务部。</div>
    	</div>
    </div>
    <div class="tag">
    	<div class="tag-top">
    		<div class="tag-top-title"> L2B服务模式</div>
    	</div>
    	<div class="pattern">
			<div class="p-left">
				<div class="p-left-name p-left-top">HR</div>
				<div class="p-left-name">财务</div>
				<div class="p-left-name p-left-bottom">老板</div>
			</div>
			<div class="p-c-list">
				<img src="/static/img/department11.png" class="p-img">
			</div>
			<div class="p-desc">
				<div class="p-c-name">获取服务</div>
				<img src="/static/img/department4.png" class="p-c-img">
				<div class="p-c-name">法律需求</div>
			</div>
			<div class="p-c-list">
				<img src="/static/img/department22.png" class="p-img">
			</div>
			<div class="p-desc">
				<div class="p-c-name">提供服务</div>
				<img src="/static/img/department4.png" class="p-c-img">
				<div class="p-c-name">办公/案源需求</div>
			</div>
			<div class="p-c-list">
				<img src="/static/img/department33.png" class="p-img">
			</div>
			<div class="p-right">
				<div class="p-right-name p-r-top"><div class="p-r-desc">主管律师</div></div>
				<div class="p-right-name"><div class="p-r-desc">主办律师</div></div>
				<div class="p-right-name p-r-bottom"><div class="p-r-desc">律师助理</div></div>
			</div>
		</div>
    </div>
    <div class="tag">
    	<div class="tag-top">
    		<div class="tag-top-title">服务特色</div>
    	</div>
    	<div class="s-list">
    		<div v-for="(item , index) in serviceList" class="s-lists">
				<img :src="item.src" class="s-img">
				<div class="s-right">
					<div class="s-name">{{item.name}}</div>
    				<div class="s-desc">{{item.desc}}</div>
				</div>
    		</div>
    	</div>
    </div>
    <div class="tag">
    	<div class="tag-top">
    		<div class="tag-top-title">商事法律服务</div>
    		<div class="tag-top-desc">针对中小企业法律服务需求零散、间断性，且具有共通性的特点，推出商事法律基础服务，
解决企业日常法律问题</div>
    	</div>
    	<div class="l-list">
    		<div  v-for="(item , index) in lawColumnList" class="l-lists">
    			<img v-if="index == 2" src="/static/img/background.png" class="p-img-bj">
    			<img :src="item.src" class="l-img">
    			<div class="l-name">{{item.name}}</div>
    			<div class="l-desc">{{item.desc}}</div>
    		</div>
    	</div>
    </div>
    <div class="bottom">
    	<div class="b-btn" @click="showMore = true">了解详情</div>
    	<img src="/static/img/hxj.png" class="b-img">
    	<div class="b-desc">底部扫码，关注小程序，实时关注最新课程哦～</div>
    </div>

    <el-col>
    	<el-dialog :visible.sync="showMore" width="25%" top="20vh">
    		<div class="dia-body">
	    		<div class="dia-list">
	    			<div>法律顾问：</div>
	    			<div class="dia-des">13302994840</div>
	    		</div>
	    		<div class="dia-list">
	    			<div>微信咨询：</div>
	    			<div class="dia-des">HS-13302994840</div>
	    		</div>
	    		<div class="dia-list last">
	    			<div>平台联系：</div>
	    			<div class="dia-btn" @click="gotoChat">私信</div>
	    		</div>
    		</div>
    	</el-dialog>
    </el-col>
  </div>
</template>

<script>
export default {
  name: 'legalDepartment',
  data () {
    return {
      serviceList:[
      	{src:'/static/img/department_service1.png',name:'服务保证',desc:'专注于企业商事法律服务,实现团队分工协作,专业互补 '},
      	{src:'/static/img/department_service2.png',name:'即时响应 ',desc:'任何法律服务需求,都能第一时间到达服务团队 '},
      	{src:'/static/img/department_service3.png',name:'降低成本',desc:'以合理的价格获得优质法律服务,为您节省更多成本'}
      ],
      lawColumnList:[
      	{src:'/static/img/department_column1.png',name:'商事法律基础服务',desc:'19800元'},
      	{src:'/static/img/department_column2.png',name:'商事法律深度服务 ',desc:'6万以上'},
      	{src:'/static/img/department_column3.png',name:'重大专项法律服务',desc:'按需付费'}
      ],
      showMore:false,
    }
  },
  computed:{
  	isLogin() {
        return this.$store.state.loginStatus;
    },
  },
  methods:{
  	//跳转私信
  	gotoChat() {
      if( !this.isLogin ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        setTimeout(() => {
          this.$message.warning( '请先登录后，再次执行操作！' );
        }, 200);
        return;
      }
      // this.$gotov1('/feed?v2chat=' + this.userInfo.id);
      this.startGetInfo(398)

    },

    startGetInfo(uid) {
      this.$ajax('get', `/userinfo/detail/${uid}`, (data) => {
          this.startChat(data.data);
      });
    },
    startChat(user) {
        if(this.$store.state.mineInfo && this.$store.state.mineInfo.id){
            this.$store.commit("changeCurcontactInfo", { id: user.id, name: user.name});

            if(!this.isshowchatpanel){
            	this.showMore = false;
                this.$store.commit('setSide', 'chat');
            }
        }else{
            this.$Message.error('未登录，请先登录后再发起私信！');
        }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/legalDepartment/legalDepartment.vue